<!-- eslint-disable vue/no-bare-strings-in-template -->
<template>
  <section class="miniStack">
    <div class="docsGriddable">
      <h3>Selects</h3>
      <BaseCard>
        <FormKit type="select" label="Select" :options="materialTypes" />
      </BaseCard>
      <BaseCard>
        <FormKit type="dropdown" label="Vue Select" :options="materialTypes" />
      </BaseCard>
      <BaseCard>
        <FormKit
          type="findandselect"
          label="Find and Select"
          placeholder="Search for a material..."
          :options="
            materialTypes.map((opt) => ({
              ...opt,
              searchData: {
                label: opt.label,
              },
            }))
          "
          :searchKeys="['label']"
          :showCount="true"
          :showOnFocus="true"
          :addOther="true"
          :onSet="onSomething('set')"
          :onClear="onSomething('clear')"
          :onSearchInput="onSomething('searchInput')"
        />
      </BaseCard>
      <BaseCard>
        <FormKit
          type="inlineselect"
          label="Inline Select"
          value="chipboard"
          :options="constructiveMaterialTypes"
          @input="onSomething('input')"
        />
      </BaseCard>
    </div>

    <div class="docsGriddable">
      <h3>Radios</h3>
      <BaseCard>
        <FormKit
          type="radio"
          label="Horizontal Radio"
          :classes="{ options: 'horizontal' }"
          :options="constructiveMaterialTypes"
        />
      </BaseCard>
      <BaseCard>
        <FormKit
          type="radio"
          label="Vertical Radio"
          :options="decorativeMaterialTypes"
        />
      </BaseCard>
    </div>

    <div class="docsGriddable">
      <h3>Checkboxes</h3>
      <BaseCard>
        <FormKit
          type="checkbox"
          label="Checkbox toggles"
          :options="constructiveMaterialTypes"
        />
      </BaseCard>
      <BaseCard>
        <FormKit
          type="checkbox"
          label="Horizontal Checkbox"
          :classes="{ options: 'horizontal text-xs' }"
          :options="decorativeMaterialTypes"
        />
      </BaseCard>
      <BaseCard>
        <FormKit
          type="checkbox"
          label="Small Checkbox"
          :classes="{ options: 'text-xs' }"
          :options="decorativeMaterialTypes"
        />
      </BaseCard>
    </div>

    <div class="docsGriddable">
      <h3>Text Inputs</h3>
      <BaseCard>
        <FormKit type="text" label="Text" value="Hello Cutr" />
      </BaseCard>
      <BaseCard>
        <FormKit
          type="unit"
          label="Numeric"
          value="123122345213452345"
          unit="hour"
          min="1"
          max="24"
        />
      </BaseCard>
      <BaseCard>
        <FormKit
          type="quantity"
          label="Quantity"
          value="3"
          name="quantity"
          placeholder="quantity"
        />
      </BaseCard>
      <BaseCard>
        <FormKit type="amount" currency="eur" label="Amount" :value="2" />
      </BaseCard>
      <BaseCard>
        <FormKit type="unit" label="Percentage" value="42" max="100" />
      </BaseCard>
      <BaseCard>
        <FormKit type="toggle" name="toggle1" label="toggle switch" />
      </BaseCard>
      <BaseCard>
        <FormKit type="textarea" label="TextArea" value="Hello Cutr" />
      </BaseCard>
      <BaseCard>
        <FormKit
          type="file"
          name="file"
          label="Select your documents to upload"
          help="Select one or more PDFs to upload"
          validation="mime:application/pdf"
          multiple
        />
      </BaseCard>
      <BaseCard>
        <FormKit
          v-model="phoneNumber"
          type="phonenumber"
          label="Phone Number"
          validation="phoneNumber"
        />
        <pre>Value: {{ phoneNumber }}</pre>
      </BaseCard>
    </div>

    <div class="docsGriddable">
      <h3>Dates</h3>
      <BaseCard>
        <FormKit
          v-model="date"
          label="Date picker"
          type="weekDatepicker"
          :minDate="dayjs().add(5, 'weeks').format('YYYY-MM-DD')"
        />
        <CButton width="fluid-width" @click="onPickNew"> Pick random </CButton>
        <pre>Value: {{ date }}</pre>
      </BaseCard>
      <BaseCard>
        <FormKit
          v-model="weekDate"
          label="Week date picker"
          type="weekDatepicker"
          popover
          :minDate="dayjs().format('YYYY-MM-DD')"
          :getClasses="bouwvakCellClass"
          help="Bouwvak days are highlighted, past days are disabled"
        />
        <pre>Value: {{ weekDate }}</pre>
      </BaseCard>
      <BaseCard>
        <FormKit
          type="autocomplete"
          v-bind="timeSelectAttrs({ start: '07:00', end: '20:00' })"
          label="Time Picker"
          name="time"
        />
      </BaseCard>
    </div>
    <div class="docsGriddable">
      <h3>Help stuff</h3>
      <BaseCard>
        <FormKit
          type="text"
          name="input"
          label="Input with help link"
          help="This is a help text for the input, defaults before input"
          helpLink="https://www.google.com"
        />
      </BaseCard>
      <BaseCard>
        <FormKit
          type="text"
          name="input"
          label="Input with help below input"
          help="This is a help text for the input and badge"
          helpBelowInput="true"
        />
      </BaseCard>
      <BaseCard>
        <FormKit
          type="text"
          name="input"
          label="Input with help tooltip"
          help="This is a help text for the input and tooltip"
          :helpTooltip="{
            content: 'This is a help tooltip for the input',
            theme: 'dark',
          }"
          helpTooltipIcon="schedule"
        />
      </BaseCard>
      <BaseCard>
        <FormKit
          type="text"
          name="input"
          label="Input with badge"
          helpBelowInput="true"
          :sectionsSchema="{
            label: {
              children: [
                'Input with badge ',
                {
                  $cmp: 'Badge',
                  props: {
                    label: 'New',
                    variant: 'new',
                    icon: 'favorite',
                    pill: true,
                  },
                },
              ],
            },
          }"
        />
      </BaseCard>
    </div>

    <div class="docsGriddable">
      <h3>Schemas</h3>
      <BaseCard>
        <FormKit type="form" :actions="false" @submit="handleSubmit">
          <FormKitSchema
            :schema="[
              ...deliveryDetailsSchema([
                { id: '1', name: 'Facility 1' },
                { id: '2', name: 'Facility 2' },
              ]),
              ...[
                {
                  $formkit: 'select',
                  name: 'country',
                  options: COUNTRY_OPTIONS(),
                  validation: 'required',
                  label: $t('order-delivery:fields.country.label'),
                },
                {
                  $formkit: 'text',
                  name: 'postcode',
                  'error-behavior': 'value',
                  validation: 'required|postcode',
                  label: $t('order-delivery:fields.postcode.label'),
                },
                {
                  $el: 'div',
                  children: [
                    {
                      $formkit: 'time',
                      name: 'startAt',
                      label: $t(
                        'order-delivery:deliverySchedule.form.startAt.label'
                      ),
                      validation: `required|naturallyBefore:endAt`,
                    },
                    {
                      $formkit: 'time',
                      name: 'endAt',
                      label: $t(
                        'order-delivery:deliverySchedule.form.endAt.label'
                      ),
                      validation: `required|naturallyAfter:startAt`,
                    },
                  ],
                },
              ],
            ]"
          />
          <CButton type="submit"> Submit </CButton>
        </FormKit>
      </BaseCard>
    </div>
  </section>
</template>
<script setup lang="ts">
import { deliveryDetailsSchema } from '@/helpers/schemas';
import { timeSelectAttrs } from '@/formkit/timeSelect';
import { COUNTRY_OPTIONS } from '@/helpers/user-helpers';
import {
  CONSTRUCTIVE_MATERIAL_CATEGORIES,
  DECORATIVE_MATERIAL_CATEGORIES,
} from '@cutr/constants/material-request';
import { bouwvakCellClass } from '@cutr/constants/bouwvak';
import dayjs from 'dayjs';
import i18next from 'i18next';
import { computed, watch } from 'vue';
import { ref } from 'vue';

const quantity = ref<number>(2);

const date = ref(new Date());
const weekDate = ref(dayjs().add(1, 'week').format('YYYY-MM-DD'));
const onPickNew = () => {
  date.value = dayjs()
    .add(Math.floor(Math.random() * 10), 'day')
    .toDate();
};

const phoneNumber = ref<string>('+31612345678');

watch(
  () => quantity.value,
  (newVal) => console.log(newVal)
);

const constructiveMaterialTypes = computed(() =>
  CONSTRUCTIVE_MATERIAL_CATEGORIES.map((type) => ({
    value: type,
    label: i18next.t(`order-materials:materialOptions.${type}`),
  }))
);

const decorativeMaterialTypes = computed(() =>
  DECORATIVE_MATERIAL_CATEGORIES.map((type) => ({
    value: type,
    label: i18next.t(`order-materials:materialOptions.${type}`),
  }))
);

const materialTypes = computed(() => [
  ...constructiveMaterialTypes.value,
  ...decorativeMaterialTypes.value,
]);

function handleSubmit(data: Record<string, unknown>) {
  console.log('data', data);
}

function onSomething(action: string) {
  return (...args: unknown[]) => console.log(action, ...args);
}
</script>
<style>
.docsGriddable {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;

  & > h3 {
    grid-column: 1 / -1;
    padding-top: 1rem;
  }
}
</style>
